import classNames from 'classnames';
import Icon from '@/components/atoms/icon/icon';
import Typography from '@/components/atoms/typography/typography';
import { useSearchContext } from '@/libraries/contexts/search-context';
import styles from './search-bar-area-selector-ledge.module.scss';

export interface SearchBarAreaSelectorLedgeProps {
  /** The available areas to choose from */
  areas: Content.Components['TravelPortalAvailableArea'][];
  /** The class name to apply */
  className?: string;
  /** Whether the component has the connection curves */
  hideConnectionCurve?: boolean;
}

const SearchBarAreaSelectorLedge = ({
  areas,
  className,
  hideConnectionCurve = false,
}: SearchBarAreaSelectorLedgeProps) => {
  const { area, setArea } = useSearchContext();

  const handleAreaClick = (
    item:
      | Content.Components['TravelPortalAvailableArea']
      | Content.Components['TravelPortalAvailableLinkArea'],
  ) => {
    setArea(item.id);

    if (item.$type === 'TravelPortalAvailableSearchArea') return;

    if (item.$type === 'TravelPortalAvailableLinkArea') {
      const { target, url } = (
        item as Content.Components['TravelPortalAvailableLinkArea']
      ).link;

      window.open(url, target);
    }
  };

  return (
    <div
      className={classNames(styles.component, className, {
        [styles.hasConnectionCurve]: !hideConnectionCurve,
      })}
    >
      <div className={styles.wrapper}>
        {areas.map((item, itemIndex) => (
          <button
            key={itemIndex}
            className={classNames(styles.button, {
              [styles.isActive]: area === item.id,
            })}
            onClick={() => handleAreaClick(item)}
          >
            <Icon name={item.icon} size={24} />

            <Typography className={styles.text} tagStyle="bodySmall">
              {item.label}
            </Typography>
          </button>
        ))}
      </div>
    </div>
  );
};

SearchBarAreaSelectorLedge.displayName = 'SearchBarAreaSelectorLedge';

export default SearchBarAreaSelectorLedge;
